import { useTranslation } from 'react-i18next';

import { useInvitationsStatistics } from '~/api/statistics';
import { useUser } from '~/api/user';
import { Card } from '~/components';
import { useIntl } from '~/hooks/useIntl';
import { DiscountProgress } from '~/pages/Settings/Invitations/DiscountProgress/DiscountProgress';

import { amountStyle, cardStyle, currentDiscountStyle, eyebrowStyle } from './DiscountProgressCard.css';

export const DiscountProgressCard = () => {
  const { data: user } = useUser();
  const { data: statistics } = useInvitationsStatistics();

  const { formatCurrency } = useIntl();
  const { t } = useTranslation(['invitations']);

  const activeInvitorDiscounts = user.invitorDiscounts.filter(({ isActive }) => isActive).length;
  const currentDiscountPercentage = activeInvitorDiscounts * 25;

  const items = ([1, 2, 3, 4] as const).map((milestone) => {
    const isActive = activeInvitorDiscounts >= milestone;

    return {
      isActive,
      label: t('invitations:discountProgress.step', { percentage: milestone * 25 }),
      hint: isActive ? undefined : t('invitations:discountProgress.hint', { count: milestone - activeInvitorDiscounts }),
    };
  });

  return (
    <Card.Root className={cardStyle} variant="primary-light">
      <div>
        <p className={eyebrowStyle}>{t('invitations:discountProgress.savedLabel')}</p>

        <p className={amountStyle}>{formatCurrency(statistics?.totalReferralProfit ?? 0)}</p>
      </div>

      <p className={currentDiscountStyle}>{t('invitations:discountProgress.currentDiscount', { percentage: currentDiscountPercentage })}</p>

      <DiscountProgress items={items} />
    </Card.Root>
  );
};
